// Action types for Liability

//Get liability List
export const GET_LIABILITY_LIST = "GET_LIABILITY_LIST";
export const GET_LIABILITY_LIST_SUCCESS = "GET_LIABILITY_LIST_SUCCESS";
export const GET_LIABILITY_LIST_FAILURE = "GET_LIABILITY_LIST_FAILURE";

//Get liability Detail
export const GET_LIABILITY_DETAIL = "GET_LIABILITY_DETAIL";
export const GET_LIABILITY_DETAIL_SUCCESS = "GET_LIABILITY_DETAIL_SUCCESS";
export const GET_LIABILITY_DETAIL_FAILURE = "GET_LIABILITY_DETAIL_FAILURE";

//Create liability
export const CREATE_LIABILITY = "CREATE_LIABILITY";
export const CREATE_LIABILITY_SUCCESS = "CREATE_LIABILITY_SUCCESS";
export const CREATE_LIABILITY_FAILURE = "CREATE_LIABILITY_FAILURE";

//Update liability
export const UPDATE_LIABILITY = "UPDATE_LIABILITY";
export const UPDATE_LIABILITY_SUCCESS = "UPDATE_LIABILITY_SUCCESS";
export const UPDATE_LIABILITY_FAILURE = "UPDATE_LIABILITY_FAILURE";

//Delete liability
export const DELETE_LIABILITY = "DELETE_LIABILITY";
export const DELETE_LIABILITY_SUCCESS = "DELETE_LIABILITY_SUCCESS";
export const DELETE_LIABILITY_FAILURE = "DELETE_LIABILITY_FAILURE";

// Get Liability Provider List
export const GET_LIABILITY_PROVIDER_LIST = "GET_LIABILITY_PROVIDER_LIST";
export const GET_LIABILITY_PROVIDER_LIST_SUCCESS =
  "GET_LIABILITY_PROVIDER_LIST_SUCCESS";
export const GET_LIABILITY_PROVIDER_LIST_FAILURE =
  "GET_LIABILITY_PROVIDER_LIST_FAILURE";

// Get Liability Provider Detail
export const GET_LIABILITY_PROVIDER_DETAIL = "GET_LIABILITY_PROVIDER_DETAIL";
export const GET_LIABILITY_PROVIDER_DETAIL_SUCCESS =
  "GET_LIABILITY_PROVIDER_DETAIL_SUCCESS";
export const GET_LIABILITY_PROVIDER_DETAIL_FAILURE =
  "GET_LIABILITY_PROVIDER_DETAIL_FAILURE";

// Create Liability Provider
export const CREATE_LIABILITY_PROVIDER = "CREATE_LIABILITY_PROVIDER";
export const CREATE_LIABILITY_PROVIDER_SUCCESS =
  "CREATE_LIABILITY_PROVIDER_SUCCESS";
export const CREATE_LIABILITY_PROVIDER_FAILURE =
  "CREATE_LIABILITY_PROVIDER_FAILURE";

// Update Liability Provider
export const UPDATE_LIABILITY_PROVIDER = "UPDATE_LIABILITY_PROVIDER";
export const UPDATE_LIABILITY_PROVIDER_SUCCESS =
  "UPDATE_LIABILITY_PROVIDER_SUCCESS";
export const UPDATE_LIABILITY_PROVIDER_FAILURE =
  "UPDATE_LIABILITY_PROVIDER_FAILURE";

// Delete Liability Provider
export const DELETE_LIABILITY_PROVIDER = "DELETE_LIABILITY_PROVIDER";
export const DELETE_LIABILITY_PROVIDER_SUCCESS =
  "DELETE_LIABILITY_PROVIDER_SUCCESS";
export const DELETE_LIABILITY_PROVIDER_FAILURE =
  "DELETE_LIABILITY_PROVIDER_FAILURE";

//Liability Status List
export const GET_LIABILITY_STATUS_LIST = "GET_LIABILITY_STATUS_LIST";
export const GET_LIABILITY_STATUS_LIST_SUCCESS =
  "GET_LIABILITY_STATUS_LIST_SUCCESS";
export const GET_LIABILITY_STATUS_LIST_FAILURE =
  "GET_LIABILITY_STATUS_LIST_FAILURE";

//Liability Status Detail
export const GET_LIABILITY_STATUS_DETAIL = "GET_LIABILITY_STATUS_DETAIL";
export const GET_LIABILITY_STATUS_DETAIL_SUCCESS =
  "GET_LIABILITY_STATUS_DETAIL_SUCCESS";
export const GET_LIABILITY_STATUS_DETAIL_FAILURE =
  "GET_LIABILITY_STATUS_DETAIL_FAILURE";

//Create Liability Status
export const CREATE_LIABILITY_STATUS = "CREATE_LIABILITY_STATUS";
export const CREATE_LIABILITY_STATUS_SUCCESS =
  "CREATE_LIABILITY_STATUS_SUCCESS";
export const CREATE_LIABILITY_STATUS_FAILURE =
  "CREATE_LIABILITY_STATUS_FAILURE";

//Update Liability Status
export const UPDATE_LIABILITY_STATUS = "UPDATE_LIABILITY_STATUS";
export const UPDATE_LIABILITY_STATUS_SUCCESS =
  "UPDATE_LIABILITY_STATUS_SUCCESS";
export const UPDATE_LIABILITY_STATUS_FAILURE =
  "UPDATE_LIABILITY_STATUS_FAILURE";

//Delete Liability Status
export const DELETE_LIABILITY_STATUS = "DELETE_LIABILITY_STATUS";
export const DELETE_LIABILITY_STATUS_SUCCESS =
  "DELETE_LIABILITY_STATUS_SUCCESS";
export const DELETE_LIABILITY_STATUS_FAILURE =
  "DELETE_LIABILITY_STATUS_FAILURE";

// Liability Item Category List
export const GET_LIABILITY_ITEM_CATEGORY_LIST =
  "GET_LIABILITY_ITEM_CATEGORY_LIST";
export const GET_LIABILITY_ITEM_CATEGORY_LIST_SUCCESS =
  "GET_LIABILITY_ITEM_CATEGORY_LIST_SUCCESS";
export const GET_LIABILITY_ITEM_CATEGORY_LIST_FAILURE =
  "GET_LIABILITY_ITEM_CATEGORY_LIST_FAILURE";

// Liability Item Category Detail
export const GET_LIABILITY_ITEM_CATEGORY_DETAIL =
  "GET_LIABILITY_ITEM_CATEGORY_DETAIL";
export const GET_LIABILITY_ITEM_CATEGORY_DETAIL_SUCCESS =
  "GET_LIABILITY_ITEM_CATEGORY_DETAIL_SUCCESS";
export const GET_LIABILITY_ITEM_CATEGORY_DETAIL_FAILURE =
  "GET_LIABILITY_ITEM_CATEGORY_DETAIL_FAILURE";

// Create Liability Item Category
export const CREATE_LIABILITY_ITEM_CATEGORY = "CREATE_LIABILITY_ITEM_CATEGORY";
export const CREATE_LIABILITY_ITEM_CATEGORY_SUCCESS =
  "CREATE_LIABILITY_ITEM_CATEGORY_SUCCESS";
export const CREATE_LIABILITY_ITEM_CATEGORY_FAILURE =
  "CREATE_LIABILITY_ITEM_CATEGORY_FAILURE";

// Update Liability Item Category
export const UPDATE_LIABILITY_ITEM_CATEGORY = "UPDATE_LIABILITY_ITEM_CATEGORY";
export const UPDATE_LIABILITY_ITEM_CATEGORY_SUCCESS =
  "UPDATE_LIABILITY_ITEM_CATEGORY_SUCCESS";
export const UPDATE_LIABILITY_ITEM_CATEGORY_FAILURE =
  "UPDATE_LIABILITY_ITEM_CATEGORY_FAILURE";

// Delete Liability Item Category
export const DELETE_LIABILITY_ITEM_CATEGORY = "DELETE_LIABILITY_ITEM_CATEGORY";
export const DELETE_LIABILITY_ITEM_CATEGORY_SUCCESS =
  "DELETE_LIABILITY_ITEM_CATEGORY_SUCCESS";
export const DELETE_LIABILITY_ITEM_CATEGORY_FAILURE =
  "DELETE_LIABILITY_ITEM_CATEGORY_FAILURE";
